
import React from "react";
import { useTranslation } from "react-i18next";
import { Popup, Grid, Icon, List, Header, Table, StateCell } from "semantic-ui-react";
import GenderIcon from "../reservation/genderIcon";
import { useHistory, useParams } from "react-router";

export default function DetailRatePopup(props) {
  const { t } = useTranslation();
  const user = JSON.parse(localStorage.getItem("userInfo"));
  let { cruise_id } = useParams();
  let history = useHistory();

  const handleClick = (bookingId) => {
    history.push(`/cruises/${cruise_id}/reservations/${props.reservation_id}/bookings/${bookingId}/spaces`)
  }

  const totales = props.spaces.reduce((acum, item) => {
    acum.price += parseFloat(item.price);
    acum.commission_price += parseFloat(item.commission_price);
    acum.flight_price += parseFloat(item.flight_price);
    acum.special_discount_price += parseFloat(item.special_discount_price);
    return acum;
  }, { price: 0, commission_price: 0, flight_price: 0, special_discount_price: 0 });

  return (
    <>
      <Popup className="max-h-[400px] overflow-y-auto" trigger={<Icon name='info' color='red' size='small' circular />} flowing hoverable>
        <Table color="blue">
          <Table.Header>
            <Table.Row align="center">
              <Table.HeaderCell></Table.HeaderCell>
              <Table.HeaderCell>Cabina<br /><br /></Table.HeaderCell>
              <Table.HeaderCell>Crucero<br /><br /></Table.HeaderCell>
              <Table.HeaderCell>Comisión<br /><br /></Table.HeaderCell>
              <Table.HeaderCell>Vuelo<br /><br /></Table.HeaderCell>
              <Table.HeaderCell>Descuento<br />Adicional</Table.HeaderCell>
              <Table.HeaderCell>Total<br /><br /></Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {props.spaces.map((space) => (
              <Table.Row align="center" key={space.id} className='hover:bg-gray-300/30 cursor-pointer' onClick={() => handleClick(space.booking_id)}>
                <Table.Cell><GenderIcon gender={space.gender_name} />
                {space.tour_leader ? <> <br /><span className="text_date_format uppercase">Tour Leader</span></> : ''}
                </Table.Cell>
                <Table.Cell><b><div style={{ color: "#1261A0", fontSize: "20px" }}>{space.cabin_name}</div></b></Table.Cell>
                <Table.Cell>$ {space.price}<br /><span className="text_date_format">{space.rate}</span></Table.Cell>
                <Table.Cell>- $ {space.commission_price}<br /><span className="text_date_format">{space.commission_percentage}%</span></Table.Cell>
                <Table.Cell>$ {space.flight_price}<br /><span className="text_date_format">{space.include_flight_ticket ? "Valor incluído en tarifa" : ""}</span></Table.Cell>
                <Table.Cell>- $ {space.special_discount_price}</Table.Cell>
                <Table.Cell align="left"><b><div>$ {space.total_price}</div></b><span className="text_date_format">Operadora: $ {space.operator_price}</span></Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>

          <Table.Footer>
            <Table.Row align="center">
              <Table.HeaderCell><b>TOTAL:</b></Table.HeaderCell>
              <Table.HeaderCell />
              <Table.HeaderCell><b><div>$ {totales.price.toFixed(2)}</div></b></Table.HeaderCell>
              <Table.HeaderCell><b><div>$ {totales.commission_price.toFixed(2)}</div></b></Table.HeaderCell>
              <Table.HeaderCell><b><div>$ {totales.flight_price.toFixed(2)}</div></b></Table.HeaderCell>
              <Table.HeaderCell><b><div>$ {totales.special_discount_price.toFixed(2)}</div></b></Table.HeaderCell>
              <Table.HeaderCell><b><div style={{ color: "#1261A0" }}>$ {props.client_price}</div></b><span className="text_date_format">Operadora: $ {props.operator_price}</span></Table.HeaderCell>
            </Table.Row>
          </Table.Footer>

        </Table>
      </Popup>
    </>
  );
}